import React from 'react';
import CheckIcon from '../Own/ui/CheckIcon';
import RedXIcon from '../Own/ui/RedXIcon';

const PricingCardHorizontal = ({ title, action, link, description, currency, price, features }) => {
    return (
        <div className="flex flex-col md:flex-row p-6 w-full text-center items-center text-gray-900 bg-blueGray-50 rounded-lg border border-gray-100 shadow dark:border-gray-600 xl:p-8 dark:bg-gray-800 dark:text-white">
            <div className="flex flex-col w-full md:w-8/12 text-center md:text-left">
                <h3 className="text-2xl font-semibold">{title}</h3>
                {description &&
                    <p className="font-light text-gray-500 sm:text-lg dark:text-gray-400">{description}</p>
                }
            </div>
            <div className="flex justify-center items-center w-full md:w-2/12 mt-4 mb-8 md:mt-0 md:mb-0">
                <span className="mr-2 text-5xl font-extrabold">{`${currency}${price}`}</span>
                {price > 0 &&
                    <>
                        <div className='uppercase text-xs text-gray-500 dark:text-gray-400 flex flex-col text-left pt-2'>
                            <span>FOREVER</span>
                            <span>{`Billed once`}</span>
                        </div>
                    </>
                }
            </div>
            <a href={link} target='_blank' rel="noreferrer" className={`${action === '' ? 'invisible' : ''} text-white bg-primary font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:text-white dark:focus:ring-sky-900 w-full md:w-2/12`}>
                {action}
            </a>
        </div>
    );
};

export default PricingCardHorizontal;